var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgMirror = function SvgMirror(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -10 144 195",
    height: 23.125,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    className: "_1sjywpl0 _1sjywpl1 bc5nciu bc5nciic bc5nci18q bc5nci4kv",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.613C0 32.063 32.062 0 71.613 0s71.613 32.062 71.613 71.613v102.505c0 6.01-4.872 10.882-10.883 10.882H10.883C4.872 185 0 180.128 0 174.118V71.613Z",
    fill: "url(#markGradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M134.717 176.111V71.821c0-34.953-28.252-63.288-63.104-63.288-34.852 0-63.105 28.335-63.105 63.289V176.11c0 .197.16.356.355.356h125.5a.354.354 0 0 0 .354-.356ZM71.613 0C32.063 0 0 32.156 0 71.822V176.11C0 181.02 3.968 185 8.863 185h125.5c4.895 0 8.863-3.98 8.863-8.889V71.821C143.226 32.157 111.164 0 71.613 0Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "markGradient",
    x1: 18.435,
    x2: 143.747,
    y1: 10.667,
    y2: 209.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#787878"
  })))));
};
export default SvgMirror;